$(document).ready(function () {
  var item_hot_box = recommend.recommend_text.split(",") || ['360', ' Bob', ' glueless', ' blonde', ' 613', ' pink', ' bundles', ' deep wave', ' bangs', ' air wig', ' v part']
  var strs = ""
  for (var i = 0; i < item_hot_box.length; i++) {
    var ele = item_hot_box[i]
    if (ele != "") {
      strs += `<div class="search_result_hot_item"><a class="hot_item" href="/search?type=product&q=${ele}"><span class="hot_title">${ele}</span></a></div>`
    }
  }
  $(".search_main_box").addClass("active")
  $(".search_main_box .search_result_box .search_result_container .search_result_item_list").html(strs)
  $(".site-header__search-container.is-active").on("input", ".site-header__search-input", function () {
    if ($(".site-header__search-container.is-active .site-header__search-input").val().length > 0) {
      $(this).removeClass("active")
      $(this).addClass("hidden")
    } else {
      $(this).addClass("active")
      $(this).removeClass("hidden")
    }
  })
})
// $(document).ready(function () {

// })
